export default {
	NEARPOD: 0,
	GOOGLE_SLIDES: 1,
}
